import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AtlasLanguageService } from '@galaxy/atlas/core';
import { SessionService } from '@galaxy/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { VDC_APP_ID } from '../../../globals';
import { Site, SiteService } from '../../core/site';
import { SelectedAccountService } from '../../selected-account.service';

interface AtlasIdentifier {
  accountId: string;
  partnerId: string;
}

@Component({
  selector: 'app-atlas-nav',
  templateUrl: './atlas.component.html',
  styleUrls: ['./atlas.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AtlasComponent implements OnInit, OnDestroy {
  serviceProviderId: string = VDC_APP_ID;
  //WSPdefaultURL is used to tell Atlas the pattern for loading a different AG-ID
  WSPdefaultURL = '/entry/<accountGroupId>';

  atlasIdentifier$: Observable<AtlasIdentifier>;

  _destroyed$$: Subject<void> = new Subject<void>();

  constructor(
    private sessionService: SessionService,
    private siteService: SiteService,
    private atlasLanguageService: AtlasLanguageService,
    private translateService: TranslateService,
    private selectedAccountService: SelectedAccountService,
  ) {}

  ngOnInit(): void {
    this.atlasIdentifier$ = this.siteService.get().pipe(
      map((res: Site) => {
        return { accountId: res.accountId, partnerId: res.partnerId };
        // Handle other cases if necessary (e.g., return default value or handle null/undefined)
      }),
    );

    this.atlasLanguageService.language$.pipe(takeUntil(this._destroyed$$)).subscribe((language) => {
      this.translateService.use(language);
    });
  }

  logout(): void {
    this.sessionService.clearSessionId();
    window.location.href = '/logout/';
  }

  ngOnDestroy(): void {
    this._destroyed$$.next();
    this._destroyed$$.complete();
  }
}
